import classnames from 'classnames'
import { FormikProvider, useFormik } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'

import useAddMembersToGroups from '../../../state/mutations/useAddMembersToGroups'
import FormButtons from '../../basics/FormButtons/FormButtons'
import { SelectUsersFormik } from '../../formElements/SelectUsers/SelectUsers'
import GroupSlugs from '../../slugs/GroupSlugs'

import styles from './AddMembersToGroupsForm.module.scss'

interface AddMembersToGroupsFormProps {
  groupUuids: string[]
  onClose: () => void
}

export default React.memo(function AddMembersToGroupsForm({ groupUuids, onClose }: AddMembersToGroupsFormProps) {
  const { t } = useTranslation()

  const addMembersToGroups = useAddMembersToGroups()
  const formik = useFormik({
    initialValues: {
      userUuids: [],
      groupUuids: groupUuids,
    },
    onSubmit: async (values, { setStatus }) => {
      setStatus()
      try {
        await addMembersToGroups.mutateAsync(values)
        onClose()
      } catch (err) {
        setStatus(err)
      }
    },
  })

  return (
    <FormikProvider value={formik}>
      <form noValidate onSubmit={formik.handleSubmit} className={classnames(styles.AddMembersToGroupsForm)}>
        <header>
          <hgroup>
            <h1>{t('manage group.add group members')}</h1>
          </hgroup>
        </header>

        <GroupSlugs uuids={formik.values.groupUuids} max={5} className={styles.groups} />

        <SelectUsersFormik name="userUuids" required label={t('search users')} />

        <FormButtons onClose={onClose} {...formik} />
      </form>
    </FormikProvider>
  )
})
